import React, { useState, useEffect, useContext } from 'react'
import firebase from 'firebase'
import '../App.css';
import { FirebaseContext } from '../firebase'
import { Nav, Navbar, Button } from 'react-bootstrap'
import { useHistory, useParams } from 'react-router-dom'

function Article() {
    const [article, setArticle] = useState("")
    const { articleId, sequenceId } = useParams()
    const [read, setRead] = useState(false)
    const { fire, user } = useContext(FirebaseContext)
    const history = useHistory()

    useEffect(() => {
        getArticle()
    }, [])

    useEffect(() => {
        if (article.readBy) {
            if (user && article.readBy.includes(user.uid)) {
                setRead(true)
            }
        }
    }, [article])

    function getArticle() {
        fire.firestore().collection('articles').doc(articleId)
            .onSnapshot((doc) => {
                if (doc.exists) {
                    setArticle({
                        id: doc.id,
                        ...doc.data()
                    })
                    console.log('set article')
                } else {
                    console.log(`Couldn't find Article by ID ${articleId}` )
                }
            })
    }

    function markRead(articleRef) {
        articleRef = fire.firestore().collection('articles').doc(articleId)
        articleRef.update({
            readBy: firebase.firestore.FieldValue.arrayUnion(user.uid)
        })
        history.push(`/sequence/${sequenceId}`)
    }

    function markUnread(articleRef) {
        articleRef = fire.firestore().collection('articles').doc(articleId)
        articleRef.update({
            readBy: firebase.firestore.FieldValue.arrayRemove(user.uid)
        })
        setRead(false)
    }

    return (
        <React.Fragment>
            <div className="viewer">
                <div>
                    <iframe title={article.title} src={article.url ? article.url : null}></iframe>
                </div>
            </div>
            <Navbar bg="light" expand="xs" className="fixed-bottom">
                    <Button variant="dark" onClick={() => history.push(`/sequence/${sequenceId}`)}>
                        <i className="fas fa-align-left"></i>
                        <span>Go back</span>
                    </Button>
                    {(user && !read) && 
                        <Button variant="outline-dark" onClick={markRead}>
                            <i className="fas fa-align-left"></i>
                            <span>Mark as read</span>
                        </Button>
                    }
                    {read && 
                        <Button variant="dark" onClick={markUnread}>
                            <i className="fas fa-align-left"></i>
                            <span>Mark as unread</span>
                        </Button>
                    }
                    <Button variant="outline-info" onClick={() => window.open(article.url, "_blank")}>
                        <i className="fas fa-align-left"></i>
                        <span>Open in new tab</span>
                    </Button>
            </Navbar>
        </React.Fragment>
    )
}


export default Article